// extracted by mini-css-extract-plugin
export default {"default-button":"Button_default-button__emhqU","disabled":"Button_disabled__Rys+p"};